module.exports = __webpack_public_path__ + "img/apple@3x.68d20904.png";